import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import FlameCanvasBackground from "@/components/FlameCanvasBackground";
import NoiseOverlay from "@/components/NoiseOverlay";
import SiteLayout from "@/components/SiteLayout";
import AdminLayout from "@/components/admin/AdminLayout";

import HomePage from "@/pages/HomePage";
import MenuPage from "@/pages/MenuPage";
import EventsPage from "@/pages/EventsPage";
import GalleryPage from "@/pages/GalleryPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";

import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminDashboardPage from "@/pages/admin/AdminDashboardPage";
import AdminMenuPage from "@/pages/admin/AdminMenuPage";
import AdminEventsPage from "@/pages/admin/AdminEventsPage";
import AdminGalleryPage from "@/pages/admin/AdminGalleryPage";
import AdminInquiriesPage from "@/pages/admin/AdminInquiriesPage";
import AdminOrdersPage from "@/pages/admin/AdminOrdersPage";
import AdminSettingsPage from "@/pages/admin/AdminSettingsPage";
import OrderPage from "@/pages/OrderPage";
import PayDepositPage from "@/pages/PayDepositPage";

import { SettingsProvider } from "@/lib/settings";
import NotFoundPage from "@/pages/NotFoundPage";

function App() {
    useEffect(() => {
        document.documentElement.classList.add("dark");
    }, []);

    return (
        <div className="App">
            <FlameCanvasBackground />
            <div className="flame-vignette" />
            <div className="flame-noise" />

            <SettingsProvider>
                <BrowserRouter>
                    <Routes>
                        {/* Public site */}
                        <Route element={<SiteLayout />}>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/menu" element={<MenuPage />} />
                            <Route path="/events" element={<EventsPage />} />
                            <Route path="/gallery" element={<GalleryPage />} />
                            <Route path="/about" element={<AboutPage />} />
                            <Route path="/contact" element={<ContactPage />} />
                            <Route path="/order" element={<OrderPage />} />
                            <Route path="/pay-deposit" element={<PayDepositPage />} />
                            <Route path="*" element={<NotFoundPage />} />
                        </Route>

                        {/* Admin */}
                        <Route path="/admin/login" element={<AdminLoginPage />} />
                        <Route element={<AdminLayout />}>
                            <Route path="/admin" element={<AdminDashboardPage />} />
                            <Route path="/admin/menu" element={<AdminMenuPage />} />
                            <Route path="/admin/events" element={<AdminEventsPage />} />
                            <Route path="/admin/gallery" element={<AdminGalleryPage />} />
                            <Route path="/admin/inquiries" element={<AdminInquiriesPage />} />
                            <Route path="/admin/orders" element={<AdminOrdersPage />} />
                            <Route path="/admin/settings" element={<AdminSettingsPage />} />
                        </Route>
                    </Routes>
                </BrowserRouter>
            </SettingsProvider>

            <Toaster richColors theme="dark" position="top-right" />
        </div>
    );
}

export default App;
